var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none",
    viewBox: "0 0 17 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.14 2.28c.52-.7.24-1.28-.63-1.28H1.89c-.87 0-1.15.57-.63 1.28L6.2 9.4v7.03c0 .45.33.68.74.51l2.52-1.03c.4-.17.74-.67.74-1.13V9.4l4.94-7.12Z",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgFilter;